import { createSelector } from "@reduxjs/toolkit";
import { getProductPickerSelectedProducts } from "@src/store/slices/productPicker";
import { ProductPickerSelectedProduct } from "@src/store/slices/productPicker/types";

export const getProductPickerSelectedProductMap = createSelector(
  getProductPickerSelectedProducts,
  (products) =>
    products.reduce(
      (lookup, product) => {
        lookup[product.id] = product;
        return lookup;
      },
      {} as Record<string, ProductPickerSelectedProduct>
    )
);
